import { render, staticRenderFns } from "./StoreUserForm.vue?vue&type=template&id=edae94b8&scoped=true&"
import script from "./StoreUserForm.vue?vue&type=script&lang=js&"
export * from "./StoreUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edae94b8",
  null
  
)

export default component.exports